import React, { forwardRef } from 'react';
import BaseTableCell from '@material-ui/core/TableCell';

const TableCell = forwardRef((props, ref) => (
  <BaseTableCell ref={ref} {...props} />
));

export default TableCell;
